export class UnprocessableEntityError extends Error {
    public readonly code: number;

    constructor(code?: number, message?: string) {
        super(message);
        this.code = code;
        Object.setPrototypeOf(this, UnprocessableEntityError.prototype);
    }
}